////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Controlled single-line text input                               //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import type { InputHTMLAttributes } from 'react';

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  invalid?: boolean;
}

export function TextInput ({ invalid = false, className = '', ...rest }: TextInputProps) {
  return (
    <input
      aria-invalid={invalid}
      className={`rounded border px-3 py-2 text-ink outline-none focus:ring-2 focus:ring-ink/40 ${invalid ? 'border-red-600' : 'border-line'} ${className}`}
      {...rest}
    />
  );
}
